// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconBookmark = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M4 1h16v20l-1.517.856L12 17.946l-6.484 3.91L4 21zm2 2v16.229l5.483-3.307h1.034L18 19.229V3z"
    />
  );
export default SvgIconBookmark;
